import { render, staticRenderFns } from "./ExtraTaxonomiesSettings.vue?vue&type=template&id=dde57488&lang=pug"
import script from "./ExtraTaxonomiesSettings.vue?vue&type=script&lang=js"
export * from "./ExtraTaxonomiesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports